export default {
  "machine-learning": {
    "passage": "{items, plural, =1 {Answer} other {Answers}} {current}/{length, number}",
    "passages": "Answers",
    "passagesCollapsed": "I found {passagesNb, number} possible answers",
    "answers": "Suggested answers",
    "answersCollapsed": "I found {answersNb, number} suggested answers",
    "answer": "Suggested answer"
  }
}